import { Component } from '@angular/core';

@Component({
  selector: 'false-add-email',
  templateUrl: './add-email.component.html',
  styles: [
  ]
})
export class AddEmailComponent {

}
